const msgJp = {
    //Message
    MESSAGE_01: "を選びなおしますか？",
    MESSAGE_02: "選びなおしますか？",
    MESSAGE_03: "検索結果がありません",
    MESSAGE_04:
        "これ以上献立に料理を追加出来ません。\n献立から料理を削除して再度追加してください。",
    MESSAGE_05:
        "これ以上食材を追加出来ません。\n食材を削除してから追加してください。",
    MESSAGE_06: "0.1g未満になる食品だけでは登録出来ません。",

    //Message error
    ERR_COMMON: "大変申し訳ございません。エラーが発生しました。",
    ERR_BROWSER:
        "ご使用のブラウザはミルミル献立計画に対応しておりません。\nChrome、Safari、Edgeでご利用ください。",
    ERR_OS: "お使いのOSは対応していません。",
    ERR_LOCAL_DATA_ACCESS:
        "CookieまたはLocal Storageが無効になっています。\nセキュリティの設定をシステム管理者にご確認ください。",
    ERR_LOGIN: "ログインできません。\nログインIDまたはパスワードが違います。",
    ERR_LICENSE: "ライセンスが有効でない可能性があります。",
    ERR_01: "操作時間外の為、アクセスできません。",
    ERR_02:
        "処理中にエラーが発生しました。\nしばらく経ってからもう一度お試しください。",
    E_003: "データが存在しない",
    ERR_OVERTIME_BT_SETTING: "先生が設定した時間以外のため、アクセスできません。",
    ERR_OVERTIME: "操作時間外のため、アクセスできません",

    //Message validate
    VALID_001: '{0}は必須項目です。',
    VALID_002: '{0}に無効な文字列が含まれています。',
    VALID_003: '{0}は有効なURL書式ではありません。',
    VALID_004: '{0}は有効なメールアドレス書式ではありません。',
    VALID_005: '{0}は半角英数字、及び「_」である必要があります。',
    VALID_006: '{0}は半角数字にしてください。',
    VALID_007: '{0}は文字列にしてください。',
    VALID_008: '{0}は{1}である必要があります。',
    VALID_009: '{0}は{1}ではいけません。',
    VALID_010: '{0}は0か1のどちらかである必要があります。',
    VALID_011: '{0}は{1}以下でなければなりません。',
    VALID_012: '{0}は{1}以上でなければなりません。',
    VALID_013: '{0}は{1}文字以下でなければなりません。',
    VALID_014: '{0}は{1}文字以上でなければなりません。',
    VALID_015: '{0}は{1}文字でなければなりません。',
    VALID_016: '{0}の{1}は既に使われています。',
    VALID_017: '{0}は全角カナにしてください。',
    VALID_018: '{0}は{1}桁である必要があります。',
    VALID_019: '{0}に無効な値が含まれています。',
    VALID_020: '{0}は{1}MB以下でなければなりません。',
    VALID_021: '{0}は{1}以上登録できません。',
    VALID_022: '{0}は半角英数字、及び「-」である必要があります。',
    VALID_023: '{0}は半角英数字、及び記号である必要があります。',
    VALID_024: '半角で入力してください',
    VALID_025: '{0}は{1}文字以下で入力してください。',
    VALID_026: '{0}は{1}g以下で入力してください。',
    MESSAGE_TIME_OUT: '利用時間が2時間経ちました。\n10分後に認証が切れますので、必要なデータを保存後、引き続き作業を行う場合は一旦ログアウトし、再度ログインを行ってください',
    MESSAGE_END_TIME: 'あと10分で操作できなくなります。現在の操作を終了しログアウトしてください。',
    MESSAGE_CONFIRM_LOGOUT: 'ログアウトしますか？',
    VALID_HIRAGANA: "ひらがなで入力してください",
    MESSAGE_LOGOUT: '認証が切れました。再度ログインを行ってください。',
    MAX_EATING_UTENSIL: "これ以上献立に箸・カトラリーを追加出来ません。\n献立から箸・カトラリーを削除して再度追加してください。",
    VALID_IMAGE: 'アップロードできる料理画像はpng、jpeg、jpg、gif、heif、heic形式となります。',
    VALID_MAX_IMAGE_SIZE: '{0}MB以上の画像はアップロードできません。'
}
export default msgJp;